export const ROWS_PER_PAGE_OPTIONS = [5, 10, 15, 25, 100];
